export const COLORS = [
	'#000000',
	'#FF4D4D',
	'#3366E6',
	'#809900',
	'#FFB399',
	'#FF33FF',
	'#00B3E6',
	'#999966',
	'#99FF99',
	'#B34D4D',
	'#80B300',
	'#E6B3B3',
	'#6680B3',
	'#FF99E6',
	'#33FFCC',
	'#B366CC',
	'#4D8000',
	'#B33300',
	'#66664D',
	'#FF6633',
	'#991AFF',
	'#E666FF',
	'#4DB3FF',
	'#1AB399',
	'#E666B3',
	'#33991A',
	'#CC9999',
	'#B3B31A',
	'#00E680',
	'#4D8066',
	'#809980',
	'#E6FF80',
	'#1AFF33',
	'#999933',
	'#FF3380',
	'#CCCC00',
	'#4D80CC',
	'#9900B3',
	'#E64D66',
	'#4DB380',
	'#99E6E6',
	'#6666FF',
];
